// Module
var code = `<app-page-content [showWebFooter]="true" [usePagePadding]="true" [pmcId]="paymentRequest.property.hoa.pmc.couponId"
    [hoaId]="paymentRequest.property.hoa.couponId" [propertyId]="paymentRequest.property.couponId">
    <app-cobrand-header [property]="paymentRequest.property.nickname" [manager]="paymentRequest.property.hoa.pmc.name"
        [association]="paymentRequest.property.hoa.name" [makePayment]="true"></app-cobrand-header>
    <div class="HOA-container">
        <div class="HOA-container__header">
            <h1 *ngIf="!isAsyncFeatureEnabled" tid="paymentConfirmationLabel" id="paymentConfirmationLabel" class="HOA-container__header-text">Payment Confirmation</h1>
            <h1 *ngIf="isAsyncFeatureEnabled" tid="paymentPendingLabel" id="paymentPendingLabel" class="HOA-container__header-text">Payment Pending</h1>
        </div>
        <div class="HOA-container__content u-textCenter">
            <div tid="thankYouLabel" id="thankYouLabel" class="HOA-splash__title--sm-bold u-pB4">
                Thank you
            </div>
            <!-- Conditional payment status message -->
            <div *ngIf="!isAsyncFeatureEnabled" tid="paymentProcessedLabel" id="paymentProcessedLabel" class="u-pB4">
                <span *ngIf="isPaymentDateToday()">Your payment for {{paymentRequest.payment.totalPaymentAmount | currency}} was processed.</span>
                <span *ngIf="!isPaymentDateToday()">
                    Your payment for {{paymentRequest.payment.totalPaymentAmount | currency}} is scheduled to be processed on {{paymentRequest.paymentDate.formattedFullDate}}.
                </span>
            </div>
            <div *ngIf="isAsyncFeatureEnabled" tid="paymentProcessedLabel" id="paymentProcessedLabel" class="u-pB4">
                <span *ngIf="isPaymentDateToday()">Your payment for {{paymentRequest.payment.totalPaymentAmount | currency}} was submitted.</span>
                <!-- Not sure about schedule payments for now -->
                <span *ngIf="!isPaymentDateToday()">
                    Your payment for {{paymentRequest.payment.totalPaymentAmount | currency}} is scheduled to be processed on {{paymentRequest.paymentDate.formattedFullDate}}.
                </span>
            </div>
            <!-- Conditional email notification message -->
            <div *ngIf="paymentRequest && !isAsyncFeatureEnabled" tid="confirmationLabel" id="confirmationLabel" class="u-pB4">
                A confirmation has been sent to {{homeowner.contactInformation.email.value}}.
                <br>
                You may also print this page for your records.
            </div>
            <div *ngIf="paymentRequest && isAsyncFeatureEnabled" tid="confirmationLabel" id="confirmationLabel" class="u-pB4">
                A confirmation email will be sent to {{homeowner.contactInformation.email.value}} when your payment has processed.
                <br>
                You may also print this page for your records.
            </div>
            <span class="Icon Icon--72 u-strokeGreenDarker u-mB4"><svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                <title *ngIf="!isAsyncFeatureEnabled">Confirmation #</title>
                <title *ngIf="isAsyncFeatureEnabled">Payment Pending</title>
                <path d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z" fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                <path d="M23.9 39l9.1 9.3 15.6-24.6" fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg></span>
            <div *ngIf="paymentRequest && !paymentRequest.futureDatedPayment && !isAsyncFeatureEnabled" tid="confirmationNumberLabel" id="confirmationNumberLabel" class="u-pB4">
                Confirmation #{{paymentConfirmationNumber}}
            </div>
            <div class="u-pB4">
                <button type="button" tid="printSuccessButton" id="printSuccessButton" class="Button Button--link" (click)="clickPrint()">Print</button>
                <button type="button" tid="okButton" id="okButton" class="Button Button--blue" (click)="goToWelcomePage()">OK</button>
            </div>
            <div class="HOA-font-fine-print HOA-make-payment-disclaimer">
                <div tid="pleaseNoteText" id="pleaseNoteText">
                    Payments are processed Monday through Friday, excluding holidays.  Payments submitted on weekends or holidays may be delayed.
                </div>
                <button *ngIf="paymentRequest && !paymentRequest.futureDatedPayment && !isAsyncFeatureEnabled"
                        type="button"
                        (click)="cancelPreCancel()"
                        class="Button--link u-pV2">
                    Cancel Payment
                </button>
            </div>
            <div id="thank-you-msg" class="HOA-splash-copy--light" [innerHTML]="thankYouMsg | inAppBrowserLink">
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;